/*
  GoRoam gallery lightbox (loaded by blocks/gr-gallery.liquid and blocks/_gr-spec.liquid).
  For every [data-gallery-root]: numbers its [data-photo] links (01 / 06, 02, 03 ...), opens the
  tapped photo full size in that root's own lightbox with previous / next (buttons, arrow keys,
  swipe), shows the caption, closes on Esc / the close button / a tap on the backdrop, and
  returns focus to the photo that opened it.
*/
const init = (root) => {
  if (root.dataset.galReady) return;
  const photos = [...root.querySelectorAll('[data-photo]')].filter((a) => a.dataset.full);
  const box = root.querySelector('[data-lightbox]');
  if (!photos.length || !box) return;
  root.dataset.galReady = '1';
  const img = box.querySelector('[data-lightbox-img]');
  const cap = box.querySelector('[data-lightbox-cap]');
  const closeBtn = box.querySelector('[data-lightbox-close]');
  const prevBtn = box.querySelector('[data-lightbox-prev]');
  const nextBtn = box.querySelector('[data-lightbox-next]');
  const pad = (n) => (n < 10 ? '0' : '') + n;
  const grid = [...root.querySelectorAll('[data-gallery] [data-photo]')].filter((a) => a.dataset.full);
  grid.forEach((a, i) => {
    const n = a.querySelector('[data-photo-n]');
    if (n) n.textContent = i === 0 ? pad(1) + ' / ' + pad(grid.length) : pad(i + 1);
  });
  let opener = null, idx = 0;
  const show = (i) => {
    idx = (i + photos.length) % photos.length;
    const a = photos[idx];
    img.src = a.dataset.full;
    const label = (a.getAttribute('aria-label') || '').replace(/, open full size$/, '');
    img.alt = label;
    if (cap) cap.textContent = (photos.length > 1 ? pad(idx + 1) + ' / ' + pad(photos.length) + '  ' : '') + label;
    const nav = photos.length > 1;
    if (prevBtn) prevBtn.hidden = !nav;
    if (nextBtn) nextBtn.hidden = !nav;
  };
  const open = (a) => {
    opener = a;
    show(photos.indexOf(a));
    box.hidden = false; box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  };
  const close = () => {
    box.hidden = true; box.classList.remove('is-open');
    document.body.style.overflow = '';
    img.removeAttribute('src');
    if (opener) opener.focus();
  };
  photos.forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); open(a); }));
  closeBtn.addEventListener('click', close);
  if (prevBtn) prevBtn.addEventListener('click', () => show(idx - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => show(idx + 1));
  box.addEventListener('click', (e) => { if (e.target === box) close(); });
  let x0 = null;
  box.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
  box.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
  });
  document.addEventListener('keydown', (e) => {
    if (box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') show(idx + 1);
    else if (e.key === 'ArrowLeft') show(idx - 1);
  });
};
document.querySelectorAll('[data-gallery-root], .grh-gallery').forEach(init);
document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-gallery-root], .grh-gallery').forEach(init));
